import { IconLinkExternal16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import { trackCreateOrRepublishAdButton } from '@/utils/tracking';
import styles from './QasaLandingPublishButton.module.css';

export const QasaLandingPublishButton = () => {
    return (
        <Button
            className={`flex items-center justify-center gap-8 mt-8 sm:mt-32 rounded-32 ${styles.qasaButton}`}
            href="/travel-api/lotr/qasa/create-listing-landing"
            fullWidth
            onClick={() => {
                trackCreateOrRepublishAdButton('qasa', null, true);
            }}>
            Publiser og lei ut med Qasa
            <IconLinkExternal16 aria-hidden />
        </Button>
    );
};
